import {connect} from 'react-redux';
import BusinessCardFooter from './BusinessCardFooter';
import * as selectors from '../selectors';

const {getBusinessCard} = selectors;

const mapStateToProps = (state) => {
    return {
        title: getBusinessCard(state).settings.footerSettings.title,
        buttonText: getBusinessCard(state).settings.footerSettings.buttonText,
        link: getBusinessCard(state).settings.footerSettings.link
    }
}

export default connect(mapStateToProps,null)(BusinessCardFooter);